import { cloneDeep } from 'lodash';

export const reconcileTemplatedSettings = (settings = {}, rubric = {}) => {
    const templated = cloneDeep(settings.templated || {});
    const criteria = rubric.criteria || [];
    const criterionIds = new Set(criteria.map(({ id }) => String(id)));

    Object.keys(templated).forEach((criterionId) => {
        if (!criterionIds.has(String(criterionId))) {
            delete templated[criterionId];
            return;
        }

        const criterion = criteria.find(({ id }) => String(id) === String(criterionId));
        const optionIds = new Set((criterion?.options || []).map(({ id }) => String(id)));
        Object.keys(templated[criterionId] || {}).forEach((optionId) => {
            if (!optionIds.has(String(optionId))) delete templated[criterionId][optionId];
        });
    });

    const hasMissingInstructions = criteria.some(({ id: criterionId, options = [] }) => {
        const criterionInstructions = templated[criterionId] || templated[String(criterionId)] || {};
        return options.some(
            ({ id: optionId }) => !Object.prototype.hasOwnProperty.call(criterionInstructions, optionId)
        );
    });

    return {
        settings: { ...settings, templated },
        hasMissingInstructions,
    };
};
